import type { Lang, StoriesResponse, StoryListItem } from '@fonus/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { keys } from '../api/queries.ts';
import { playStory, unlockAudio } from '../audio/engine.ts';
import { useUi } from '../state/ui.ts';
import { haptic } from '../telegram/tg.ts';
import { isLocked, optimisticOpen } from './catalog.ts';

/** Tap on a story (featured card, row, continue). Must be called from the tap handler. */
export function usePlayItem(lang: Lang) {
  const qc = useQueryClient();
  const open = useUi((s) => s.open);
  return useCallback(
    (item: StoryListItem, opts: { openPlayer?: boolean } = {}) => {
      const data = qc.getQueryData<StoriesResponse>(keys.stories(lang));
      if (data && isLocked(item, data)) {
        haptic.select();
        open({ kind: 'paywall', story: { id: item.id, title: item.title, hue: item.hue } });
        return;
      }
      // Inside the gesture: unlock the audio element before any await.
      unlockAudio();
      haptic.tap();
      optimisticOpen(qc, item.id);
      if (opts.openPlayer !== false) open({ kind: 'player' });
      void playStory(
        {
          id: item.id,
          title: item.title,
          summary: item.summary,
          hue: item.hue,
          durationSec: item.durationSec,
          isTonight: item.isTonight,
        },
        lang,
      );
    },
    [qc, lang, open],
  );
}
